<template>
    <div>
        <template v-if="crud_employee === true">
            <div v-show="showData === true">
                <!-- Modal -->
                <div class="modal fade" id="personalDetailEdit" tabindex="-1" role="dialog" aria-labelledby="personalDetailEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editPersonalDetailData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Personal Detail</h2>
                                        <button :disabled="personal_detail_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Full Name </label>
                                        <input v-model="personal_detail_form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': personal_detail_form.errors.has('name') }">
                                        <has-error :form="personal_detail_form" field="name"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Father Name </label>
                                        <input v-model="personal_detail_form.father_name" type="text" name="father_name" class="form-control" :class="{ 'is-invalid': personal_detail_form.errors.has('father_name') }">
                                        <has-error :form="personal_detail_form" field="father_name"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Date of Birth </label>
                                        <datepicker name="dob" v-model="personal_detail_form.dob" input-class="datepicker" :bootstrap-styling="true" :class="{ 'is-invalid': personal_detail_form.errors.has('dob') }"></datepicker>
                                        <has-error :form="personal_detail_form" field="dob"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> CNIC </label>
                                        <input v-model="personal_detail_form.cnic" type="text" name="cnic" class="form-control" :class="{ 'is-invalid': personal_detail_form.errors.has('cnic') }">
                                        <has-error :form="personal_detail_form" field="cnic"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Email </label>
                                        <input v-model="personal_detail_form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': personal_detail_form.errors.has('email') }">
                                        <has-error :form="personal_detail_form" field="email"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Mobile </label>
                                        <input v-model="personal_detail_form.mobile_no" type="text" name="mobile_no" class="form-control" :class="{ 'is-invalid': personal_detail_form.errors.has('mobile_no') }">
                                        <has-error :form="personal_detail_form" field="mobile_no"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Address </label>
                                        <input v-model="personal_detail_form.current_address" type="text" name="current_address" class="form-control" :class="{ 'is-invalid': personal_detail_form.errors.has('current_address') }">
                                        <has-error :form="personal_detail_form" field="current_address"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Gender </label>
                                        <select v-model="personal_detail_form.gender" name="gender" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': personal_detail_form.errors.has('gender') }" v-if="cities != null">
                                            <option value="" selected>Gender</option>
                                            <option value="MALE">Male</option>
                                            <option value="FEMALE">Female</option>
                                        </select>
                                        <has-error :form="personal_detail_form" field="gender"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="emergencyDetailEdit" tabindex="-1" role="dialog" aria-labelledby="emergencyDetailEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editEmergencyDetailData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employee Emergency Detail</h2>
                                        <button :disabled="emergency_detail_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Name </label>
                                        <input v-model="emergency_detail_form.contact_person_name" type="text" name="contact_person_name" class="form-control" :class="{ 'is-invalid': emergency_detail_form.errors.has('contact_person_name') }">
                                        <has-error :form="emergency_detail_form" field="contact_person_name"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Email </label>
                                        <input v-model="emergency_detail_form.contact_person_email" type="email" name="contact_person_email" class="form-control" :class="{ 'is-invalid': emergency_detail_form.errors.has('contact_person_email') }">
                                        <has-error :form="emergency_detail_form" field="contact_person_email"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Mobile Number </label>
                                        <input v-model="emergency_detail_form.contact_person_mobile_no" type="text" name="contact_person_mobile_no" class="form-control" :class="{ 'is-invalid': emergency_detail_form.errors.has('contact_person_mobile_no') }">
                                        <has-error :form="emergency_detail_form" field="contact_person_mobile_no" maxLength="12"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Relationship </label>
                                        <input v-model="emergency_detail_form.contact_person_relation" type="text" name="contact_person_relation" class="form-control" :class="{ 'is-invalid': emergency_detail_form.errors.has('contact_person_relation') }">
                                        <has-error :form="emergency_detail_form" field="contact_person_relation"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="employmentDetailEdit" tabindex="-1" role="dialog" aria-labelledby="employmentDetailEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editEmploymentDetailData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employment Detail</h2>
                                        <button :disabled="employment_detail_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Employee Code </label>
                                        <input v-model="employment_detail_form.employee_code" type="text" name="employee_code" class="form-control" :class="{ 'is-invalid': employment_detail_form.errors.has('employee_code') }">
                                        <has-error :form="employment_detail_form" field="employee_code"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Department <em class="required">*</em> </label>
                                        <select v-model="employment_detail_form.department_id" data-live-search="true" name="department_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('department_id') }" v-if="departments != null" @change="getDesignationsByDepartment(true)">
                                            <option value="" selected>Select Department</option>
                                            <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">
                                                {{ department.name }}
                                            </option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="department_id"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Designation <em class="required">*</em> </label>
                                        <select v-model="employment_detail_form.designation_id" name="designation_id" data-live-search="true" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('designation_id') }" v-if="designations != null" @change="getReportToUsers">
                                            <option value="" selected>Select Designation</option>
                                            <option v-for="designation in designations" v-bind:value="designation.id" v-bind:key="designation.id">
                                                {{ designation.name }}
                                            </option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="designation_id"></has-error>
                                    </div>
                                    <!-- <div class="form-group">
                                        <label class="label block-label"> Report To </label>
                                        <select v-model="employment_detail_form.report_to_user" data-live-search="true" name="report_to_user" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('report_to_user') }" >
                                            <option value="" selected>Select User</option>
                                            <option v-for="report_to_user in report_to_users" v-bind:value="report_to_user.id" v-bind:key="report_to_user.id">
                                                {{ report_to_user.name }}
                                            </option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="report_to_user"></has-error>
                                    </div> -->
                                    <div class="form-group">
                                        <label class="label block-label"> Manager  <em class="required">*</em> </label>
                                        <select v-model="employment_detail_form.manager_id" name="manager_id" data-live-search="true" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('manager_id') }" v-if="managers != null">
                                            <option value="" selected>Select Manager</option>
                                            <option v-for="manager in managers" v-bind:value="manager.id" v-bind:key="manager.id">
                                                {{ manager.name }}
                                            </option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="manager_id"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> PMS Role </label>
                                        <select v-model="employment_detail_form.pms_role" name="pms_role" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('pms_role') }" >
                                            <option value="EMPLOYEE">Employee</option>
                                            <option value="REPORTING_MANAGER">Reporting Manager</option>
                                            <option value="HR">HR</option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="pms_role"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> City <em class="required">*</em> </label>
                                        <select v-model="employment_detail_form.city_id" data-live-search="true" name="city_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('city_id') }" v-if="cities != null">
                                            <option value="" selected>Select City</option>
                                            <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                                {{ city.name }}
                                            </option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="city_id"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Branch  <em class="required">*</em> </label>
                                        <select v-model="employment_detail_form.branch_id" data-live-search="true" name="branch_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_detail_form.errors.has('branch_id') }" v-if="branches != null">
                                            <option value="" selected>Select Branch</option>
                                            <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">
                                                {{ branch.name }}
                                            </option>
                                        </select>
                                        <has-error :form="employment_detail_form" field="branch_id"></has-error>
                                    </div>
                                    
                                    <div class="form-group">
                                        <label class="label block-label"> Hire Date <em class="required">*</em> </label>
                                        <datepicker name="date_of_joining" v-model="employment_detail_form.date_of_joining" input-class="datepicker" :bootstrap-styling="true" :class="{ 'is-invalid': employment_detail_form.errors.has('date_of_joining') }"></datepicker>
                                        <has-error :form="employment_detail_form" field="date_of_joining"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="employmentStatusEdit" tabindex="-1" role="dialog" aria-labelledby="employmentStatusEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editEmploymentStatusData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employment Status</h2>
                                        <button :disabled="employment_status_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Employee Type <em class="required">*</em> </label>
                                        <select v-model="employment_status_form.type" name="type" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_status_form.errors.has('type') }">
                                            <option value="">Status</option>
                                            <option value="PERMANENT">Permanent</option>
                                            <option value="CONTRACTUAL">Contractual</option>
                                            <option value="PROBATION">Probation</option>
                                            <option value="INTERN">Intern</option>
                                            <option value="RESIGNED">Resigned</option>
                                            <option value="TERMINATED">Terminated</option>
                                            <option value="ONLEAVE">Onleave</option>
                                            <option value="PIECE_RATE">Piece Rate</option>
                                        </select>
                                        <has-error :form="employment_status_form" field="type"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Smart Phone </label>
                                        <select v-model="employment_status_form.smart_phone" name="smart_phone" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_status_form.errors.has('smart_phone') }">
                                            <option value="YES">Yes</option>
                                            <option value="NO">No</option>
                                        </select>
                                        <has-error :form="employment_status_form" field="smart_phone"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Status </label>
                                        <select v-model="employment_status_form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_status_form.errors.has('status') }">
                                            <option value="ACTIVE">Active</option>
                                            <option value="INACTIVE">In Active</option>
                                        </select>
                                        <has-error :form="employment_status_form" field="status"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Provident Fund </label>
                                        <select v-model="employment_status_form.provident_fund" name="provident_fund" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': employment_status_form.errors.has('provident_fund') }">
                                            <option value="OPT_IN">OPT_IN</option>
                                            <option value="OPT_OUT">OPT_OUT</option>
                                        </select>
                                        <has-error :form="employment_status_form" field="provident_fund"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="employmentWorkAddressEdit" tabindex="-1" role="dialog" aria-labelledby="employmentWorkAddressEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editEmploymeeWorkAddressData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employment Detail</h2>
                                        <button :disabled="work_address_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Work Address </label>
                                        <input v-model="work_address_form.address" type="text" name="address" class="form-control" :class="{ 'is-invalid': work_address_form.errors.has('address') }">
                                        <has-error :form="work_address_form" field="address"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="employmeePaymentDetailEdit" tabindex="-1" role="dialog" aria-labelledby="employmeePaymentDetailEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-5 text-left">
                                <div class="popup-head mb-4 line-head">
                                    <h2 class="pb-3"> Payment Detail </h2>
                                </div>
                                <easyPaisaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EASY_PAISA'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <fincaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FINCA'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <meezanBeneficiaryComponent v-if="$global.user_company_payment_engine == 'MEEZAN'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <nbpFundsBeneficiaryComponent v-if="$global.user_company_payment_engine == 'NBP_FUND'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <faysalBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FAYSAL'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <emoneyBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EMONEY'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                
                                <div class="people-management-inner-content">
                                    <div class="btn-holder text-right">
                                        <button class="btn btn-primary" @click="hidePopup()"> Cancel </button>
                                        <button class="btn btn-primary" @click="addEmployeePaymentDetail()" disable="disable"> Save </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="employmeeSalaryDetailEdit" tabindex="-1" role="dialog" aria-labelledby="employmeeSalaryDetailEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editSalaryDetailData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employee Salary</h2>
                                        <button :disabled="salary_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Gross Salary </label>
                                        <input v-model="salary_form.net_salary" type="text" @keypress="isNumber($event)" name="net_salary" class="form-control" :class="{ 'is-invalid': salary_form.errors.has('net_salary') }">
                                        <has-error :form="salary_form" field="net_salary"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="incomeTaxEdit" tabindex="-1" role="dialog" aria-labelledby="incomeTaxEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editIncomeTaxDetailData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employee Income Tax</h2>
                                        <button :disabled="tax_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Advance Tax Paid </label>
                                        <input v-model="tax_form.advance_tax_paid" type="text" name="advance_tax_paid" class="form-control" :class="{ 'is-invalid': tax_form.errors.has('advance_tax_paid') }">
                                        <has-error :form="tax_form" field="advance_tax_paid"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="providentFundEdit" tabindex="-1" role="dialog" aria-labelledby="providentFundEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editProvidentFundDetailData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employee Provident Fund</h2>
                                        <button :disabled="provident_fund_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Advance Provident Employee Contribution </label>
                                        <input v-model="provident_fund_form.advance_provident_employee_contribution" type="text" name="advance_provident_employee_contribution" class="form-control" :class="{ 'is-invalid': provident_fund_form.errors.has('advance_provident_employee_contribution') }">
                                        <has-error :form="provident_fund_form" field="advance_provident_employee_contribution"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="label block-label"> Advance Provident Company Contribution: </label>
                                        <input v-model="provident_fund_form.advance_provident_company_contribution" type="text" name="advance_provident_company_contribution" class="form-control" :class="{ 'is-invalid': provident_fund_form.errors.has('advance_provident_company_contribution') }">
                                        <has-error :form="provident_fund_form" field="advance_provident_company_contribution"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="employeeEdit" tabindex="-1" role="dialog" aria-labelledby="employeeEdit" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editEmployeeLeaveData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Employee Leave Time off Policy</h2>
                                        <button :disabled="time_off_submit" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close">Cancel</a>
                                    </div>
                                    <div v-if="leave_obj.fullleaveQouta && leave_obj.fullleaveQouta.length > 0">
                                        <div v-for="leave in leave_obj.fullleaveQouta" v-bind:value="leave.id" v-bind:key="leave.id">

                                            <h2>{{leave.title}} Time off Policy <span> Total Leaves : {{leave.total}}</span></h2>
                                            <div class="people-view-popup-content">
                                                <label class="radio-holder">
                                                    Yes
                                                    <input type="radio" :name="`casual_time_off[${leave.id}]`" :value="casual_time_off[leave.id] == 1 ? 1:'' " v-on:change="radioChange(leave.id,1)" v-model="casual_time_off[leave.id]">
                                                    <span class="checkmark"></span>
                                                </label> 
                                                <label class="radio-holder">
                                                    No
                                                    <input type="radio" :name="`casual_time_off[${leave.id}]`" :value="casual_time_off[leave.id] == 0 ? 1:'' " v-on:change="radioChange(leave.id,0)" v-model="casual_time_off[leave.id]">
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-group">
                                                    <label> Balance </label>
                                                    <input type="number" step="any" :name="`balance[${leave.id}]`" :id="`balance_${leave.id}`" :value="checkOldLeave(leave.id) !== false ? checkOldLeave(leave.id) : leave.balance " :max="parseFloat(leave.total)" min="0" class="form-control"/>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-top mb-1 mb-3 clearfix">
                    <div class="pm-employee-info float-left">
                        <!-- <div class="image-holder">
                            <img :src="$global.aws_base_url+'/avatar/'+personal_detail_form.avatar" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                        </div> 
                        
                        <div id="image-preview" class="image-holder" :style="'background: url('+this.$global.base_url+'avatar/'+this.form.image+');'">
                            <input type="file" name="image" id="image-upload" class="form-control" v-on:change="onImageChange"/>
                        </div>
                        -->

                        <div class="profile-image">
                            <div v-if="form.image == null" id="image-preview" class="user-image-holder" :style="'background: url('+this.$global.base_url+'images/table-dummy-image.jpg); '">
                                <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                            </div>
                            <div v-else-if="form.image != null" id="image-preview" class="user-image-holder" :style="'background: url('+$global.aws_base_url+'/avatar/'+this.form.image+');'">
                                <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                            </div>
                            <div v-else id="image-preview" class="user-image-holder" :style="'background: url('+preview+');'">
                                <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                            </div>
                            <span class="update-image">
                                <i class="fas fa-pencil-alt"></i>
                            </span>
                        </div>
                        <div class="info">
                            <strong class="title"> {{personal_detail_form.name}} </strong>
                            <p> {{employment_detail_form.designation}} </p>
                        </div>
                    </div>
                    <router-link to="/employees" class="btn btn-primary mt-2 float-right"> Close</router-link>
                    <button v-if="deleteable" @click="deleteEmployee(employee_id)" class="btn btn-primary mt-2 float-right mr-1">Delete Employee</button>
                </div>
                <div class="employee-view-tabs mb-4">
                    <ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="false">Personal</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="job-detail-tab" data-toggle="tab" href="#job-detail" role="tab" aria-controls="job-detail" aria-selected="true">Job Detail</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="pay-detail-tab" data-toggle="tab" href="#pay-detail" role="tab" aria-controls="pay-detail" aria-selected="false">Pay Details</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="time-off-tab" data-toggle="tab" href="#time-off" role="tab" aria-controls="time-off" aria-selected="false">Time Off</a>
                        </li>
                        <li class="nav-item" v-show="company_income_tax == 'ENABLED'">
                            <a class="nav-link" id="income-tax-tab" data-toggle="tab" href="#income-tax" role="tab" aria-controls="income-tax" aria-selected="false">Income Tax</a>
                        </li>
                        <li class="nav-item" v-show="company_provident_fund == 'ENABLED' && employee_provident_fund == 'OPT_IN'">
                            <a class="nav-link" id="provident-fund-tab" data-toggle="tab" href="#provident-fund" role="tab" aria-controls="provident-fund" aria-selected="false">Provident Fund</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="salary-slip-tab" data-toggle="tab" href="#salary-slip" role="tab" aria-controls="salary-slip" aria-selected="false">Salary Slip</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" v-if="employee_permissions == true" id="shifts-tab" data-toggle="tab" href="#shifts" role="tab" aria-controls="shifts" aria-selected="false">User Permissions</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" v-if="email_preferences == true" id="email-preferences-tab" data-toggle="tab" href="#email_preferences" role="tab" aria-controls="email_preferences" aria-selected="false">Email Preferences</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Personal Detail </span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#personalDetailEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Full Name: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.name}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Father Name: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.father_name}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Date of Birth: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.dob}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> CNIC: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.cnic}} </p> </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4"> <strong class="title"> Email: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.email}} </p> </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4"> <strong class="title"> Mobile: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.mobile_no}} </p> </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4"> <strong class="title"> Address: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.current_address}} </p> </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4"> <strong class="title"> Gender: </strong> </div>
                                            <div class="col-md-8"> <p> {{personal_detail_form.gender}} </p> </div>
                                        </div>
                                    </div>
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Emergency Contact Detail </span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#emergencyDetailEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Name: </strong> </div>
                                            <div class="col-md-8"> <p> {{emergency_detail_form.contact_person_name == null ? '---' : emergency_detail_form.contact_person_name}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Relationship: </strong> </div>
                                            <div class="col-md-8"> <p> {{emergency_detail_form.contact_person_relation == null ? '---' : emergency_detail_form.contact_person_relation}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Mobile Number: </strong> </div>
                                            <div class="col-md-8"> <p> {{emergency_detail_form.contact_person_mobile_no == null ? '---' : emergency_detail_form.contact_person_mobile_no}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Email: </strong> </div>
                                            <div class="col-md-8"> <p> {{emergency_detail_form.contact_person_email == null ? '---' : emergency_detail_form.contact_person_email}} </p> </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - Amount {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="job-detail" role="tabpanel" aria-labelledby="job-detail-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Employment Detail </span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#employmentDetailEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Employee Code: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.employee_code == '' ? 'Employee Code not set' : employment_detail_form.employee_code}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Designation: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.designation_id == null ? "No designation selected" : employment_detail_form.designation}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Department: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.department_id == null ? "No department selected" : employment_detail_form.department}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> City: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.city_id == null ? "No city selected" : employment_detail_form.city}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Branch: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.branch_id == null ? "No branch selected" : employment_detail_form.branch}} </p> </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4"> <strong class="title"> Manager: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.manager == null ? "There is no manager" : employment_detail_form.manager}} </p> </div>
                                        </div>
                                         <div class="row">
                                            <div class="col-md-4"> <strong class="title"> PMS Role: </strong> </div>
                                            <div class="col-md-8"> <p>{{ (employment_detail_form.pms_role == null || employment_detail_form.pms_role == '' )? "No PMS role defined" : employment_detail_form.pms_role}}</p></div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Date of Joining: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.date_of_joining | date_format}} </p> </div>
                                        </div>
                                        <!-- <div class="row">
                                            <div class="col-md-4"> <strong class="title"> Report To: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_detail_form.report_to_user_name == null ? "There is no report to user" : employment_detail_form.report_to_user_name}} </p> </div>
                                        </div> -->
                                       
                                    </div>
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Employment Status </span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#employmentStatusEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Type: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_status_form.type}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Smart Phone: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_status_form.smart_phone}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Status: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_status_form.status}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Provident Fund: </strong> </div>
                                            <div class="col-md-8"> <p> {{employment_status_form.provident_fund}} </p> </div>
                                        </div>
                                    </div>
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Work Address </span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#employmentWorkAddressEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Address: </strong> </div>
                                            <div class="col-md-8"> <p> {{work_address_form.address == null ? "No Address Found" : work_address_form.address}} </p> </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pay-detail" role="tabpanel" aria-labelledby="pay-detail-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Default Beneficiary</span>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Payment Method:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ payment_method }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Account Number:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ wallet }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Salary Details</span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#employmeeSalaryDetailEdit"
                                            v-if="crud_employee == true">
                                            <i class="fas fa-pencil-alt"></i>
                                        </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Gross Salary:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ salary_form.net_salary | formatAmount }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Beneficiaries</span>
                                        <a href="#" class="float-right" @click="loadBankList" v-if="crud_employee == true">
                                            <i class="fas fa-pencil-alt"></i>
                                        </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <strong>Acount Title</strong>
                                            </div>
                                            <div class="col-sm-3">
                                                <strong>Acount Number</strong>
                                            </div>
                                            <div class="col-sm-3">
                                                <strong>Bank name</strong>
                                            </div>
                                            <div class="col-sm-3">
                                                <strong>Beneficiary Status</strong>
                                            </div>
                                        </div>
                                        <div class="row" v-for="beneficiary in beneficiaries" v-bind:key="beneficiary.id" v-bind:value="beneficiary.id">
                                            <div class="col-sm-3">{{ beneficiary.account_title }}</div>
                                            <div class="col-sm-3">{{ beneficiary.account_number }}</div>
                                            <div class="col-sm-3">{{ beneficiary.bank_name }}</div>
                                            <div class="col-sm-3">
                                                <a href="javascript:void(0);" @click="makeDefault(beneficiary.id)" v-if="beneficiary.is_default == 'NO'">Mark Default</a>
                                                <a v-if="beneficiary.is_default == 'YES'">Default <i class="fa fa-check-circle" style="font-size:18px;color:green"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="time-off" role="tabpanel" aria-labelledby="time-off-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <div v-if="leave_obj.fullleaveQouta && leave_obj.fullleaveQouta.length > 0">
                                        <label class="label block-label highlight-color mb-3 clearfix">
                                            <span class="highlight-color float-left"> Applied Policies </span>
                                            <a href="#" class="float-right"  data-toggle="modal" data-target="#employeeEdit"> <i class="fas fa-pencil-alt"></i> </a>
                                        </label>
                                        <div class="pm-employee-detail-box mb-3" v-if="leave_obj.leaveQouta && leave_obj.leaveQouta.length > 0">
                                            <div v-for="leave in leave_obj.leaveQouta" v-bind:value="leave.id" v-bind:key="leave.id">
                                                <div class="time-off-head clearfix">
                                                    <span class="title float-left"> {{leave.title}} Policy </span>
                                                    <span class="available-leaves float-right"> Available Leaves : {{leave.total}} Day(s) </span>
                                                </div>
                                                <ul class="applied-time-off">
                                                    <li class="applied-time-off-list">
                                                        Current Balance: <span class="gray-text">{{leave.balance}}</span> days
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="pm-employee-detail-box mb-3" v-else>
                                            <p class="text-center">No Leave policy assign to user.</p>
                                        </div>
                                        <div class="table-holder" v-if="leave_obj.leaves && leave_obj.leaves.length > 0">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Applied Date</th>
                                                        <th>Reason</th>
                                                        <th>Duration</th>
                                                        <th class="text-center">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="leave in leave_obj.leaves" v-bind:value="leave.id" v-bind:key="leave.id">
                                                        <td>{{leave.created_at | date_format}} {{leave.created_at | time_format}}</td>
                                                        <td>{{leave.description}}</td>
                                                        <td v-if="leave.leave_start == leave.leave_end">
                                                            {{leave.leave_start | Day_month_first_format}}
                                                        </td>
                                                        <td v-else>
                                                            {{leave.leave_start | Day_month_first_format}}, {{leave.leave_end | Day_month_first_format}}
                                                        </td>
                                                        <td>{{leave.leave_status}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else>
                                        No leave(s) defined.
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="income-tax" role="tabpanel" aria-labelledby="income-tax-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Income Tax Detail </span>
                                        <a href="#" class="float-right"  data-toggle="modal" data-target="#incomeTaxEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Advance Tax Paid: </strong> </div>
                                            <div class="col-md-8"> <p> {{tax_form.advance_tax_paid}} </p> </div>
                                        </div>
                                    </div>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Income Tax: </strong> </div>
                                            <div class="col-md-8"> <p> {{income_tax_obj.incomeTax}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Paid Tax: </strong> </div>
                                            <div class="col-md-8"> <p> {{income_tax_obj.paidTax}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Remaining Tax: </strong> </div>
                                            <div class="col-md-8"> <p> {{income_tax_obj.remainingTax}} </p> </div>
                                        </div>
                                    </div>
                                    <div class="table-holder">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Month & Year</th>
                                                    <th class="text-center">Tax Deduction</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(tax_details, key) in income_tax_obj.records" v-bind:value="tax_details.id" v-bind:key="tax_details.id">
                                                    <td>{{key}}</td>
                                                    <td class="text-center">
                                                        {{tax_details}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="provident-fund" role="tabpanel" aria-labelledby="provident-fund-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left"> Provident Fund </span>
                                        <a href="#" class="float-right"  data-toggle="modal" data-target="#providentFundEdit" v-if="crud_employee == true"> <i class="fas fa-pencil-alt"></i> </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Advance Provident Employee Contribution: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_form.advance_provident_employee_contribution}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Advance Provident Company Contribution: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_form.advance_provident_company_contribution}} </p> </div>
                                        </div>
                                    </div>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Joining Date: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_obj.joiningDate.date | date_format}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Company Contribution Date: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_obj.companyContributionDate.date | date_format}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Employee Contribution: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_obj.employeeContribution}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Company Contribution: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_obj.companyContribution}} </p> </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4"> <strong class="title"> Total Provident Fund: </strong> </div>
                                            <div class="col-md-8"> <p> {{provident_fund_obj.totalFund}} </p> </div>
                                        </div>
                                    </div>
                                    <div class="table-holder">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Month & Year</th>
                                                    <th class="text-center">Employee Contribution</th>
                                                    <th class="text-center">Company Contribution</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(provident_fund, key) in provident_fund_obj.records" v-bind:value="provident_fund.id" v-bind:key="provident_fund.id">
                                                    <td>{{key}}</td>
                                                    <td class="text-center">
                                                        {{provident_fund.employee}}
                                                    </td>
                                                    <td class="text-center">
                                                        {{provident_fund.company}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="salary-slip" role="tabpanel" aria-labelledby="salary-slip-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="table-holder">
                                        <table class="table" v-if="payroll_sheet && payroll_sheet.length > 0">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Processed Date</th>
                                                    <th>Net Payable</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="ps in payroll_sheet" v-bind:value="ps.id" v-bind:key="ps.id">
                                                    <td>{{ps.payroll.name}}</td>
                                                    <td>{{ps.payroll.created_at | date_format}}</td>
                                                    <td>{{ps.net_salary}} </td>
                                                    <td class="text-center">
                                                        <a href="#" @click="downloadSalarySlip(ps.id)" data-toggle="tooltip" data-placement="top" title="Download" class="action"><i class="fas fa-download"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-else class="alert alert-warning">There is no salary slip against this employee.</div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="payroll_processed.length > 0">
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Payroll Processed </h2>
                                        <span class="highlight-color d-block mb-3"> Most Recent Payroll ({{last_payroll_date | date_format}}) </span>

                                        <p> Previous Payroll </p>
                                        <select v-model="selected_batch" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="batch in payroll_processed" v-bind:value="batch.payrollId" v-bind:key="batch.id">
                                                {{batch.created_at | date_format}} - {{batch.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="openBatchDetail">View Payroll</button>
                                    </div>
                                    <div class="pm-right-sidebar mb-2 mt-2 p-3">
                                        <h2 class="mb-0"> Download Previous Salary Slip </h2>
                                        <select v-model="selected_batch" data-live-search="true" class="form-control selectpicker custom-select2" v-if="payroll_processed != null">
                                            <option v-for="payslip in payroll_processed" v-bind:value="payslip.id" v-bind:key="payslip.id">
                                                {{payslip.created_at | date_format}} - {{payslip.net_salary | formatAmount}}
                                            </option>
                                        </select>
                                        <br>
                                        <button class="btn btn-primary" @click="downloadSalarySlip(selected_batch)">Download Salary Slip</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="shifts" role="tabpanel" aria-labelledby="shifts-tab">
                        <div class="pm-employee-view-main">
                            <div class="row people-management-inner-content">
                                <div class="col-md-12">
                                    <div class="user-permissions">
                                        <form @submit.prevent="editEmployeePermissions">
                                            <label class="label block-label"> <span class="highlight-color"> Role </span> </label>
                                            <div class="form-group">
                                                <select v-on:change="getPermission($event)" v-model="user_permission_form.role_id" name="role_id" class="selectpicker custom-select2" :class="{ 'is-invalid': user_permission_form.errors.has('role_id') }" v-if="roles != null">
                                                    <option value="" selected>Select Role</option>
                                                    <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                                                        {{ role.name }}
                                                    </option>
                                                </select>
                                                <has-error :form="user_permission_form" field="role_id"></has-error>
                                            </div>
                                            <template v-if="permissions != null">
                                                <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                                    <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                                    <div class="permissions-box">
                                                        <div class="row">
                                                            <div class="col-md-6 mb-2" v-for="child in permission" v-bind:key="child.id">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                                    <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="user_permission_form.rolePermissions" />
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="btn-holder align-right"> <button :disabled="user_permission_form.busy" class="btn btn-primary"> Save </button> </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="email_preferences" role="tabpanel" aria-labelledby="email-preferences-tab">
                        <div class="pm-employee-view-main">
                            <div class="row people-management-inner-content">
                                <div class="col-md-12">
                                    <div class="user-permissions">
                                        <form @submit.prevent="editEmployeeEmailPreferences">
                                            <template>
                                                <div class="form-group">
                                                    <label class="label block-label"> <span class="highlight-color">Emails Preference</span> </label>
                                                    <div class="permissions-box">
                                                        <div class="row">
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Salary slip </span> 
                                                                    <input type="checkbox" :value="user_email_preference_form.salary_slip"
                                                                     id="email_preference_salary_slip" v-model="user_email_preference_form.salary_slip" />
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Vendor payment </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.vendor_payment"
                                                                     id="email_preference_vendor_payment" v-model="user_email_preference_form.vendor_payment"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> To maker after batch approval </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.to_maker_after_batch_approval"
                                                                     id="email_preference_to_maker_after_batch_approval" v-model="user_email_preference_form.to_maker_after_batch_approval"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Otp processing </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.otp_processing"
                                                                     id="email_preference_otp_processing" v-model="user_email_preference_form.otp_processing"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 

                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> On boarding approval </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.on_boarding_approval"
                                                                     id="email_preference_on_boarding_approval" v-model="user_email_preference_form.on_boarding_approval"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> System Notifier </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.system_notifier"
                                                                     id="email_preference_system_notifier" v-model="user_email_preference_form.system_notifier"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Send for maker </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.send_for_maker"
                                                                     id="email_preference_send_for_maker" v-model="user_email_preference_form.send_for_maker"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Send for checker </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.send_for_checker"
                                                                     id="email_preference_send_for_checker" v-model="user_email_preference_form.send_for_checker"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Send for approver </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.send_for_approver"
                                                                     id="email_preference_send_for_approver" v-model="user_email_preference_form.send_for_approver"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Reject checker </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.reject_checker"
                                                                     id="email_preference_reject_checker" v-model="user_email_preference_form.reject_checker"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Enquiry </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.enquiry"
                                                                     id="email_preference_enquiry" v-model="user_email_preference_form.enquiry"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> To maker after approval </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.to_maker_after_approval"
                                                                     id="email_preference_to_maker_after_approval" v-model="user_email_preference_form.to_maker_after_approval"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Attendance correction rejection </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.attendance_correction_rejection"
                                                                     id="email_preference_attendance_correction_rejection" v-model="user_email_preference_form.attendance_correction_rejection"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Attendance correction </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.attendance_correction"
                                                                     id="email_preference_attendance_correction" v-model="user_email_preference_form.attendance_correction"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Attendance correction line manager </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.attendance_correction_line_manager"
                                                                     id="email_preference_attendance_correction_line_manager" v-model="user_email_preference_form.attendance_correction_line_manager"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                               <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Leaves application </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.leaves_application"
                                                                     id="email_preference_leaves_application" v-model="user_email_preference_form.leaves_application"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Manager mail </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.manager_mail"
                                                                     id="email_preference_manager_mail" v-model="user_email_preference_form.manager_mail"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                            <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Leaves application reject approver </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.leaves_application_reject_approver"
                                                                     id="email_preference_leaves_application_reject_approver" v-model="user_email_preference_form.leaves_application_reject_approver"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                              <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Team confirmation </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.team_confirmation"
                                                                     id="email_preference_team_confirmation" v-model="user_email_preference_form.team_confirmation"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                              <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Compaign enquiry </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.compaign_enquiry"
                                                                     id="email_preference_compaign_enquiry" v-model="user_email_preference_form.compaign_enquiry"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                              <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> Manager rejection </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.manager_rejection"
                                                                     id="email_preference_manager_rejection" v-model="user_email_preference_form.manager_rejection"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                              <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> New joiner </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.new_joiner"
                                                                     id="email_preference_new_joiner" v-model="user_email_preference_form.new_joiner"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                              <div class="col-md-4 mb-2">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> welcome </span> 
                                                                    <input type="checkbox"  :value="user_email_preference_form.welcome"
                                                                     id="email_preference_welcome" v-model="user_email_preference_form.welcome"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div> 
                                                                                                                       
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="btn-holder align-right"> <button :disabled="user_email_preference_form.busy" class="btn btn-primary"> Save </button> </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="showData === false">
                <preLoader></preLoader>
            </div>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    import EditEmployeeLeftSide from './partial/EditEmployeeLeftSide';
    import easyPaisaBeneficiaryComponent from '../partial/easyPaisaBeneficiaryComponent.vue';
    import meezanBeneficiaryComponent from '../partial/meezanBeneficiaryComponent.vue';
    import fincaBeneficiaryComponent from '../partial/fincaBeneficiaryComponent.vue';
    import nbpFundsBeneficiaryComponent from '../partial/nbpFundsBeneficiaryComponent';
    import faysalBeneficiaryComponent from '../partial/faysalBeneficiaryComponent';
    import emoneyBeneficiaryComponent from '../partial/emoneyBeneficiaryComponent';
    export default {
        components: {
            easyPaisaBeneficiaryComponent,
            meezanBeneficiaryComponent,
            fincaBeneficiaryComponent,
            nbpFundsBeneficiaryComponent,
            faysalBeneficiaryComponent,
            emoneyBeneficiaryComponent,
            EditEmployeeLeftSide
        },
        data() {
            return {
                editMode : 'YES',
                personal_detail_form: new Form({
                    name: "",
                    father_name: "",
                    dob: "",
                    cnic: "",
                    email: "",
                    mobile_no: "",
                    current_address: "",
                    gender: "",
                    avatar: "",
                    uid: this.$route.params.id
                }),
                emergency_detail_form: new Form({
                    contact_person_name: "",
                    contact_person_relation: "",
                    contact_person_mobile_no: "",
                    contact_person_email: "",
                    uid: this.$route.params.id
                }),
                employment_detail_form: new Form({
                    employee_code: "",
                    designation: "",
                    department: "",
                    branch: "",
                    city: "",
                    manager: "",
                    designation_id: "",
                    department_id: "",
                    branch_id: "",
                    city_id: "",
                    manager_id: "",
                    date_of_joining: "",
                    uid: this.$route.params.id,
                    report_to_user: "", // id of the user
                    report_to_user_name: "",
                    pms_role: "",
                }),
                employment_status_form: new Form({
                    type: "",
                    smart_phone: "",
                    status: "",
                    provident_fund: "",
                    uid: this.$route.params.id
                }),
                work_address_form: new Form({
                    address: "",
                    uid: this.$route.params.id
                }),
                payment_form: new Form({
                    accountType : '',
                    bank : '',
                    accountNumber : '',
                    cnic : '',
                    is_default : '',
                    paymentMethod : '',
                    account_detail : false,
                    account_information : {
                        customer_name : '',
                        account_number : '',
                        bank_name : '',
                    },
                    id : this.$route.params.id
                }),
                make_default : new Form({
                    id : '',
                    uid: this.$route.params.id
                }),
                salary_form : new Form({
                    net_salary : '',
                    uid: this.$route.params.id
                }),
                tax_form : new Form({
                    advance_tax_paid: '',
                    uid: this.$route.params.id
                }),
                provident_fund_form : new Form({
                    advance_provident_employee_contribution: '',
                    advance_provident_company_contribution: '',
                    uid: this.$route.params.id
                }),
                user_permission_form : new Form({
                    role_id : '',
                    rolePermissions : [],
                    userPermissions : [],
                    uid: this.$route.params.id
                }),
                user_email_preference_form : new Form({
                    salary_slip : false,
                    vendor_payment : false,
                    to_maker_after_batch_approval : false,
                    otp_processing : false,
                    on_boarding_approval : false,
                    system_notifier : false,
                    send_for_maker : false,
                    send_for_checker : false,
                    send_for_approver : false,
                    reject_checker : false,
                    enquiry : false,
                    to_maker_after_approval : false,
                    attendance_correction_rejection : false,
                    attendance_correction : false,
                    attendance_correction_line_manager : false,
                    leaves_application : false,
                    manager_mail : false,
                    leaves_application_reject_approver : false,
                    team_confirmation : false,
                    compaign_enquiry : false,
                    manager_rejection : false,
                    new_joiner : false,
                    welcome : false,
                    uid: this.$route.params.id
                }),
                income_tax_obj: {},
                leave_obj: {},
                provident_fund_obj: {
                    joiningDate: {
                        date: null,
                    },
                    companyContributionDate: {
                        date: null,
                    },
                },
                form: new Form({
                    image: "",
                    uid: this.$route.params.id
                }),
                payroll_sheet: [],
                payroll_processed: [],
                payment_method: null,
                wallet: null,
                customerNumber: '',
                beneficiaries: null,
                banks: null,
                mobileNumber: '',
                bankName : '',
                accountNumber : '',
                accountTitle : '',
                branchCode : '',
                designations : null,
                paymentMethod: 'SIMSIM',
                showWalletDetail: false,
                showIBFTDetail: false,
                cities : null,
                branches: null,
                departments: null,
                managers: null,
                role : {},
                permissions : null,
                roles: null,
                salary_slip: null,
                vendor_payment: null,
                to_maker_after_batch_approval : null,
                otp_processing : null,
                on_boarding_approval : null,
                system_notifier : null,
                send_for_maker : null,
                send_for_checker : null,
                send_for_approver : null,
                reject_checker : null,
                enquiry : null,
                to_maker_after_approval : null,
                attendance_correction_rejection : null,
                attendance_correction : null,
                attendance_correction_line_manager : null,
                leaves_application : null,
                manager_mail : null,
                leaves_application_reject_approver : null,
                team_confirmation : null,
                compaign_enquiry : null,
                manager_rejection : null,
                new_joiner : null,
                welcome : null,
                last_payroll_date: null,
                selected_batch: null,
                crud_employee: null,
                employee_permissions: null,
                email_preferences: null,
                company_income_tax: null,
                company_provident_fund: null,
                employee_provident_fund: null,
                showData: false,
                deleteable : null,
                time_off_submit: false,
                report_to_users: null,

                casual_time_off:[]
            }
        },
        methods: {
            onImageChange(e){
                this.form.image = e.target.files[0];
                this.formSubmit(e);
            },
            formSubmit(e) {
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                formData.append('image', this.form.image);
                formData.append('uid', this.form.uid);

                axios.post('/api/updateUserProfileImage', formData, config)
                .then(res => {
                    if(res.data.status == 200){
                        $('#image-preview').attr('style','background: url('+this.$global.aws_base_url+"/avatar/"+res.data.avatar+');');
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: res.data.msg
                        });
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', res.data.msg);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            },
            checkOldLeave(leaveId){
                let leaveArray = this.leave_obj.leaveQouta;
                var data = this.$global.checkIdExist(leaveId, leaveArray);
                if(data !== undefined){
                    return data.balance;
                }else{
                    return false;
                }
            },
            radioChange(key,value){
                this.casual_time_off[key] = value;
            },
            editEmployeeLeaveData(){
                this.time_off_submit = true;
                var data = {};
                data.uid = this.$route.params.id;
                data.balance = [];
                data.casual_time_off = this.casual_time_off;
                var obj = this.leave_obj.fullleaveQouta;
                if(obj && obj.length > 0){
                    _.forEach(obj, function(d, i){
                        data.balance[d.id] = $('input#balance_'+d.id).val();
                    });
                }
                axios.post('/api/updateLeaveDetail', data)
                .then(res => {
                    if (res.status == 200) {
                         $('#employeeEdit').modal('hide');
                        this.time_off_submit = false;
                        this.getEditEmployeeData();
                        this.showToastBox('success','Employee leave policy updated successfully');
                        this.$Progress.finish();
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getEditEmployeeData() {
                let that = this;
                this.pageView = false;
                this.$Progress.start();
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            // tab details
                            this.company_income_tax = res.data.company.incomeTaxModule;
                            this.company_provident_fund = res.data.company.providentFundModule;
                            this.employee_provident_fund = res.data.user.provident_fund;
                            // personal details
                            this.form.image = res.data.user.avatar;
                            this.personal_detail_form.name = res.data.user.name;
                            this.personal_detail_form.father_name = res.data.user.father_name;
                            this.personal_detail_form.dob = res.data.user.dob;
                            this.personal_detail_form.cnic = res.data.user.cnic;
                            this.personal_detail_form.email = res.data.user.email;
                            this.personal_detail_form.mobile_no = res.data.user.mobile_no;
                            this.personal_detail_form.current_address = res.data.user.current_address;
                            this.personal_detail_form.gender = res.data.user.gender;
                            this.personal_detail_form.avatar = res.data.user.avatar;
                            // emergency details
                            this.emergency_detail_form.contact_person_name = res.data.user.contact_name;
                            this.emergency_detail_form.contact_person_relation = res.data.user.contact_relation;
                            this.emergency_detail_form.contact_person_mobile_no = res.data.user.contact_number;
                            this.emergency_detail_form.contact_person_email = res.data.user.contact_email;
                            // employment details
                            this.employment_detail_form.employee_code = res.data.user.employeeCode;
                            this.employment_detail_form.designation_id = res.data.user.designation_id;
                            this.employment_detail_form.department_id = res.data.user.department_id;
                            this.employment_detail_form.city_id = res.data.user.city_id;
                            this.employment_detail_form.branch_id = res.data.user.branch_id;
                            this.employment_detail_form.manager_id = res.data.user.manager_id;
                            this.employment_detail_form.date_of_joining = res.data.user.joining_date;
                            this.employment_detail_form.pms_role = res.data.user.pms_role;
                            this.employment_detail_form.report_to_user = res.data.user.report_to;
                            this.employment_detail_form.report_to_user_name = res.data.report_to_user_name;
                            if(this.employment_detail_form.designation_id != null && this.employment_detail_form.designation_id != 0){
                                this.employment_detail_form.designation = res.data.user.designation.name;
                            }else{
                                this.employment_detail_form.designation_id = null;
                            }
                            if(this.employment_detail_form.department_id != null && this.employment_detail_form.department_id != 0){
                                this.employment_detail_form.department = res.data.user.department.name;
                            }else{
                                this.employment_detail_form.department_id = null;
                            }
                            if(this.employment_detail_form.city_id != null && this.employment_detail_form.city_id != 0){
                                this.employment_detail_form.city = res.data.user.city.name;
                            }else{
                                this.employment_detail_form.city_id = null;
                            }
                            if(this.employment_detail_form.branch_id != null && this.employment_detail_form.branch_id != 0){
                                this.employment_detail_form.branch = res.data.user.branch.name;
                            }else{
                                this.employment_detail_form.branch_id = null;
                            }
                            if(this.employment_detail_form.manager_id != null && this.employment_detail_form.manager_id != 0){
                                if(res.data.manager != null){
                                    this.employment_detail_form.manager = res.data.manager.name;
                                }else{
                                    this.employment_detail_form.manager ='';
                                }
                            }else{
                                this.employment_detail_form.manager = null;
                            }
                            this.designations = res.data.designations;
                            this.cities = res.data.cities;
                            this.branches = res.data.branches;
                            this.departments = res.data.departments;
                            this.managers = res.data.users;
                            this.report_to_users = res.data.report_to_users;
                            this.getDesignationsByDepartment(false);
                            // employment status
                            this.employment_status_form.type = res.data.user.employment_status;
                            this.employment_status_form.smart_phone = res.data.user.smart_phone;
                            this.employment_status_form.status = res.data.user.status;
                            this.employment_status_form.provident_fund = res.data.user.provident_fund;
                            // work address
                            this.work_address_form.address = res.data.user.work_address;
                            // payment dateils
                            if (res.data.user.default_beneficiary != null) {
                                this.payment_method = res.data.user.default_beneficiary.account_type;
                                this.wallet = res.data.user.default_beneficiary.account_number;
                            }
                            if (res.data.user.beneficiaries != null) {
                                this.beneficiaries = res.data.user.beneficiaries;
                            }
                            if(res.data.bankList != null){
                                this.banks = res.data.bankList;
                            }
                            this.salary_form.net_salary = res.data.user.net_salary;
                            // leaves data
                            this.leave_obj = res.data.leaveData;
                            var leave_obj = res.data.leaveData.leaveQouta;
                            _.forEach(leave_obj, function(e, i){
                                var key = e.id;
                                that.casual_time_off[key] = 1;
                            });

                            // income tax
                            this.income_tax_obj = res.data.incomeTax;
                            this.tax_form.advance_tax_paid = res.data.user.advance_tax_paid;
                            // provident fund
                            this.provident_fund_obj = res.data.providentFund;
                            this.provident_fund_form.advance_provident_employee_contribution = res.data.user.advance_provident_employee_contribution;
                            this.provident_fund_form.advance_provident_company_contribution = res.data.user.advance_provident_company_contribution;
                            // salary slip
                            this.payroll_sheet = res.data.payrollSheet;
                            this.payroll_processed = res.data.payrollProcessed;
                            if (this.payroll_processed.length > 0) {
                                this.last_payroll_date = this.payroll_processed[0].created_at;
                            }
                            // user permission
                            this.roles = res.data.roles;
                            this.permissions = res.data.permissions;
                            $.each(res.data.userPermissions, (key, value) => {
                                this.user_permission_form.rolePermissions.push(value.id);
                            });
                            this.user_permission_form.role_id = res.data.user.role_id;
                            this.deleteable = res.data.delete_able;


                            this.user_email_preference_form.salary_slip = res.data.UserEmailPreference.salary_slip == "YES" ? true : false;
                            this.user_email_preference_form.vendor_payment = res.data.UserEmailPreference.vendor_payment == "YES" ? true : false;
                            this.user_email_preference_form.to_maker_after_batch_approval = res.data.UserEmailPreference.to_maker_after_batch_approval == "YES" ? true : false;
                            this.user_email_preference_form.otp_processing = res.data.UserEmailPreference.otp_processing == "YES" ? true : false;
                            this.user_email_preference_form.on_boarding_approval = res.data.UserEmailPreference.on_boarding_approval == "YES" ? true : false;
                            this.user_email_preference_form.system_notifier = res.data.UserEmailPreference.system_notifier == "YES" ? true : false;
                            this.user_email_preference_form.send_for_maker = res.data.UserEmailPreference.send_for_maker == "YES" ? true : false;
                            this.user_email_preference_form.send_for_checker = res.data.UserEmailPreference.send_for_checker == "YES" ? true : false;
                            this.user_email_preference_form.send_for_approver = res.data.UserEmailPreference.send_for_approver == "YES" ? true : false;
                            this.user_email_preference_form.reject_checker = res.data.UserEmailPreference.reject_checker == "YES" ? true : false;
                            this.user_email_preference_form.enquiry = res.data.UserEmailPreference.enquiry == "YES" ? true : false;
                            this.user_email_preference_form.to_maker_after_approval = res.data.UserEmailPreference.to_maker_after_approval == "YES" ? true : false;
                            this.user_email_preference_form.attendance_correction_rejection = res.data.UserEmailPreference.attendance_correction_rejection == "YES" ? true : false;
                            this.user_email_preference_form.attendance_correction = res.data.UserEmailPreference.attendance_correction == "YES" ? true : false;
                            this.user_email_preference_form.attendance_correction_line_manager = res.data.UserEmailPreference.attendance_correction_line_manager == "YES" ? true : false;
                            this.user_email_preference_form.leaves_application = res.data.UserEmailPreference.leaves_application == "YES" ? true : false;
                            this.user_email_preference_form.manager_mail = res.data.UserEmailPreference.manager_mail == "YES" ? true : false;
                            this.user_email_preference_form.leaves_application_reject_approver = res.data.UserEmailPreference.leaves_application_reject_approver == "YES" ? true : false;
                            this.user_email_preference_form.team_confirmation = res.data.UserEmailPreference.team_confirmation == "YES" ? true : false;
                            this.user_email_preference_form.compaign_enquiry = res.data.UserEmailPreference.compaign_enquiry == "YES" ? true : false;
                            this.user_email_preference_form.manager_rejection = res.data.UserEmailPreference.manager_rejection == "YES" ? true : false;
                            this.user_email_preference_form.new_joiner = res.data.UserEmailPreference.new_joiner == "YES" ? true : false;
                            this.user_email_preference_form.welcome = res.data.UserEmailPreference.welcome == "YES" ? true : false;

                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .then(res=>{
                    if(this.crud_employee == true){
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showData = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            changeAccountDetail(){
                this.payment_form.account_detail = false;
            },
            hidePopup(){
                $('#employmeePaymentDetailEdit').modal('hide');
            },
            makeDefault(id){
                this.$Progress.start();
                this.make_default.id = id;
                this.make_default.post('/api/makeEmployeeDefaultBeneficiary')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        this.showToastBox('success','Employee account set to default successfully');
                        this.$Progress.finish();
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getEmployeeWalletDetail(){
                this.$Progress.start();
                if(this.form.paymentMethod == 'BANK' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.form.accountNumber;
                    if (accNo.length < 14 || accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be in between 14 to 24 digits');
                        return false;
                    }
                }
                if(this.form.paymentMethod == 'IBFT' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.form.accountNumber;
                    if (accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be 24 digits');
                        return false;
                    }
                }
                this.payment_form.post('/api/getEmployeeWalletDetail')
                .then(res => {
                    if(res.data.code == 200){
                        this.payment_form.account_detail = this.payment_form.accountType;
                        this.payment_form.account_detail = this.payment_form.accountType;
                        this.payment_form.account_information.customer_name = res.data.data.accountTitle;
                        this.payment_form.account_information.account_number = this.payment_form.accountNumber;
                        if(this.payment_form.accountType == 'IBFT'){
                            this.payment_form.account_information.bank_name = this.payment_form.bank.bank_name;
                            this.payment_form.account_information.bank_code = this.payment_form.bank.bank_code;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getDefaultWallet(){
                var uid = this.$route.params.id;
                this.$Progress.start();
                axios.post('/api/getEmployeeDefaultWallet', {
                    uid: uid
                })
                .then(res => {
                    if(res.data.status == 200){
                        this.payment_form.wallet_number = res.data.data;
                        this.beneficiaries = res.data.beneficiaries;
                        if(this.beneficiaries.length > 0){
                            this.payment_form.is_default = 'NO';
                        }else{
                            this.payment_form.is_default = 'YES';
                        }
                        this.showWalletDetail = false;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                    this.getDefault = true;
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            addEmployeePaymentDetail() {
                this.$Progress.start();
                this.payment_form.post('/api/addEmployeePaymentDetail/'+this.payment_form.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.getDefaultWallet();
                            this.showToastBox('success','Employee beneficiary added successfully');
                            $("#employmeePaymentDetailEdit").modal("hide");
                        }else if(res.data.status == 409){
                            this.$Progress.fail();
                            this.showAlertBox('error','Beneficiary details already added against this employee.');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getPermission(event) {
                this.$Progress.start();
                axios.get('/api/getEmployeeRolePermissionData/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.user_permission_form.rolePermissions = [];
                        $.each(res.data.permissions, (key, value) => {
                            this.user_permission_form.rolePermissions.push(value.id);
                            this.user_permission_form.userPermissions = this.user_permission_form.rolePermissions;
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load permissions');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load permissions');
                });
            },
            downloadSalarySlip(id){
                this.$Progress.start();
                axios.get('/api/downloadMySalarySlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Salary Slip.pdf'
                        link.click();
                        this.showToastBox('success','File Downloaded Successfully');
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Something Went Wrong Please Try Again');
                    }

                });
            },
            reset(){
                this.getEditEmployeeData();
            },
            editPersonalDetailData(){
                this.$Progress.start();
                this.personal_detail_form.post('/api/updateEmployeePersonalDetail')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#personalDetailEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee personal details updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editEmergencyDetailData(){
                this.$Progress.start();
                this.emergency_detail_form.post('/api/updateEmployeeEmergencyDetail')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#emergencyDetailEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee emergency details updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editEmploymentDetailData(){
                this.$Progress.start();
                this.employment_detail_form.post('/api/updateEmploymentDetail')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#employmentDetailEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee details updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editEmploymentStatusData(){
                this.$Progress.start();
                this.employment_status_form.post('/api/updateEmployeeStatus')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#employmentStatusEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee status updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editEmploymeeWorkAddressData(){
                this.$Progress.start();
                this.work_address_form.post('/api/updateEmployeeWorkAddress')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#employmentWorkAddressEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee work address updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editSalaryDetailData(){
                this.$Progress.start();
                this.salary_form.post('/api/updateEmployeeSalaryDetail')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#employmeeSalaryDetailEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee salary details updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editIncomeTaxDetailData(){
                this.$Progress.start();
                this.tax_form.post('/api/updateEmployeeIncomeTaxDetail')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#incomeTaxEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee income tax details updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editProvidentFundDetailData(){
                this.$Progress.start();
                this.provident_fund_form.post('/api/updateEmployeeProvidentFundDetail')
                .then(res => {
                    if (res.status == 200) {
                        this.getEditEmployeeData();
                        $("#providentFundEdit").modal("hide");
                        this.$Progress.finish();
                        this.showToastBox('success','Emplyee provident fund details updated successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data.');
                });
            },
            editEmployeePermissions() {
                this.$Progress.start();
                this.user_permission_form.post('/api/updateEmployeeUserPermission')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Employee permissions updated successfully');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },

            editEmployeeEmailPreferences() {
                this.$Progress.start();
                this.user_email_preference_form.post('/api/UpdateEmployeeEmailPreferences')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Employee Email Preference updated successfully');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            loadBankList(){
                this.showData = false;
                axios.get('/api/ibftBankList')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.bankList != null){
                            this.banks = res.data.bankList;
                        }
                        this.showData = true;
                        $("#employmeePaymentDetailEdit").modal("show");
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Error to load data');
                });
            },
            openBatchDetail(){
                this.$router.push('/viewEmployeePaymentBatchSheet/'+this.selected_batch);
            },
            deleteEmployee(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/deleteEmployee/'+id)
                        .then(res => {
                            if(res.status == 200){
                                $('#dt-complete-profile').DataTable().ajax.reload();
                                this.showAlertBox('success','Your employee has been deleted');
                            }else{
                                this.showAlertBox('error','Error to delete employee');
                            }
                        })
                        .catch(err => {
                            this.showAlertBox('error','Error to delete employee');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },

            getDesignationsByDepartment(userAddMode)
            {
                this.designations = [];

                if(userAddMode === true)
                {
                    this.report_to_users = [];
                }

                this.$Progress.start();

                axios.post('/api/getDepartmentsById', {department_id: this.employment_detail_form.department_id})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.designations = res.data.designations;
                    }
                    else
                    {
                        this.showAlertBox('error','Error to load data');
                    }
                    this.$Progress.finish();
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });

            },

            getReportToUsers()
            {
                this.report_to_users = [];
                this.employment_detail_form.report_to_user = '';
                $(this.$el).find('.selectpicker').selectpicker('refresh');
                // this.$Progress.start();
                // axios.post('/api/getReportToUsers', 
                //     {
                //         department_id: this.employment_detail_form.department_id,
                //         designation_id: this.employment_detail_form.designation_id,
                //     }
                // )
                // .then(res => {
                //     this.report_to_users = res.data.report_to_users;
                //     this.$Progress.finish();
                // })
                // .then(res=>{
                    
                // })
                // .catch(err => {
                //     this.$Progress.fail();
                //     this.showAlertBox('error','Error to load data');
                // });
            }
        },
        mounted() {
            this.can('crud_employee|employee_permissions|email_preferences').then(result => {
                this.crud_employee = result.crud_employee;
                this.employee_permissions = result.employee_permissions;
                this.email_preferences = result.email_preferences;
            }).then(result => {
                if(this.crud_employee == true){
                    if(this.$global.user_company_payment_engine == 'FINCA'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'SIMSIM';
                    }else if(this.$global.user_company_payment_engine == 'MEEZAN'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'EMONEY';
                    }else if(this.$global.user_company_payment_engine == 'EASY_PAISA'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'EASY_PAISA_WALLET';
                    }else if(this.$global.user_company_payment_engine == 'NBP_FUND'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'NBP_FUND';
                    }
                    this.getEditEmployeeData();
                }
            });
        }
    }
</script>
